import { Modal } from "antd";
import React from "react";

const TestimonialModal = ({
    isModalOpen,
    setIsModalOpen,
    modalData,
}) => {

    const handleCancel = () => {
        setIsModalOpen(false);
    };
    
    return (
        <>
            <Modal
                className="modal-styles"
                open={isModalOpen}
                onCancel={handleCancel}
                footer={null}
                // width={600}
                maskClosable={false}
                centered={true}
                title={false}
            >
                <div className="row">
                    <div className="col-md-12">
                        <h5 className="table-heading mb-0 ">Testimonial Details</h5>
                    </div>
                </div>
                <div className="modal-content">
                    <div className="section-style">
                        <div className="row space-between">
                            <div className="col-md-12 px-2">
                                <h6 className="heading-title">Title</h6>
                                <h6 className="test-p-list text-break">
                                    {modalData?.title ?? " "}
                                </h6>
                            </div>
                        </div>
                        <div className="row space-between">
                            <div className="col-md-12 px-2">
                                <h6 className="heading-title">Description</h6>
                                <h6 className="test-p-list text-break">
                                    {modalData?.description ?? " "}
                                </h6>
                            </div>
                        </div>
                        <div className="row space-between">
                            <div className="col-md-12 px-2">
                                <h6 className="heading-title">User Name</h6>
                                <h6 className="test-p-list text-break">
                                    {modalData?.user_name ?? " "}
                                </h6>
                            </div>
                        </div>
                        <div className="row space-between">
                            <div className="col-md-12 px-2">
                                <h6 className="heading-title">User Job Detail</h6>
                                <h6 className="test-p-list text-break">
                                    {modalData?.job_title ?? " "}
                                </h6>
                            </div>
                        </div>
                        <div className="row space-between">
                            <div className="col-md-12 px-2">
                                <h6 className="heading-title">User Image</h6>
                                <img src={modalData?.user_image} alt="user image" style={{ height: '150px', width: '150px', borderRadius: '50%' }} />
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};
export default TestimonialModal;
